import { render, staticRenderFns } from "./LessonTimeSelector.vue?vue&type=template&id=5436b574&scoped=true&"
import script from "./LessonTimeSelector.vue?vue&type=script&lang=js&"
export * from "./LessonTimeSelector.vue?vue&type=script&lang=js&"
import style0 from "./LessonTimeSelector.vue?vue&type=style&index=0&id=5436b574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5436b574",
  null
  
)

export default component.exports